import { env } from "@/config"
import getUserRandomName from "@/utils/getRandomUserName"
import getLocation from "@/utils/getLocation"
import store from "../index"

const DEFAULT_HEAD = require("../../assets/images/default_header.png")
const DEFAULT_HEAD_1 = require("../../assets/images/default_header_1.png")

export default {
  namespaced: true,
  state: {
    userInfo: {
      userUuid: "",
      userName: getUserRandomName(),
      userAvatarImg: DEFAULT_HEAD,
      userAvatarImg_1: DEFAULT_HEAD_1
    },
    userPosition: {
      lng: "",
      lat: ""
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    userPosition: state => state.userPosition
  },
  mutations: {
    setUserInfo(state, userInfo) {
      userInfo.userAvatarImg = DEFAULT_HEAD
      window.console.log("userInfo", userInfo)
      state.userInfo = { ...state.userInfo, ...userInfo }
    },
    setUserPosition(state, postion) {
      state.userPosition = postion
    }
  },
  actions: {
    async getNfplusUserByLogin({ commit, rootState }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return true
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid && !!stateUserInfo.phone
      if (hasUserInfo) {
        return hasUserInfo
      }
      let userInfo = await window.nfplusJsbridge.nativeLogin()
      const hasUserUuid = !!userInfo.userUuid
      if (hasUserUuid) {
        commit("setUserInfo", userInfo)
        hasUserInfo = true
      } else {
        hasUserInfo = false
      }
      return hasUserInfo
    },
    async getNfplusUserInfo({ rootState, commit }) {
      const { isNfPlus } = rootState.systemInfo
      if (!isNfPlus) return
      const stateUserInfo = rootState.userInfo.userInfo
      let hasUserInfo = !!stateUserInfo.userUuid
      if (hasUserInfo) {
        return hasUserInfo
      }
      let userInfo = await window.nfplusJsbridge.getUserInfo()
      // window.console.log("userInfo", userInfo)
      hasUserInfo = !!userInfo.userUuid
      if (hasUserInfo) {
        commit("setUserInfo", userInfo)
      }
      store.dispatch("activityInfo/getMyMessageList")
      return hasUserInfo
    },
    async getWxUserInfo({ commit, rootState }) {
      const { isWx } = rootState.systemInfo
      if (!isWx) return
      const userInfo = await window.nfWxAuth.getWxUserInfo({
        env,
        needSaveLocalStorage: true
      })
      if (userInfo) {
        commit("setUserInfo", userInfo)
      }
    },
    async getUserInfo({ rootState, dispatch }) {
      const { isWx, isNfPlus } = rootState.systemInfo
      if (isWx) {
        await dispatch("getWxUserInfo")
      }
      if (isNfPlus) {
        await dispatch("getNfplusUserInfo")
      }
    },
    async setUserNameByLocation({ commit, state, rootState }) {
      try {
        const hasUserUuid = !!state.userInfo.useruuid
        const isNfPlus = rootState.systemInfo.isNfPlus
        if (hasUserUuid && !isNfPlus) return
        const { city, position } = await getLocation()
        if (position) {
          commit("setUserPosition", position)
        }
        if (city) {
          const cityReg = /市$/
          const userName = getUserRandomName(city.replace(cityReg, ""))
          const oldUserName = state.userInfo.userName
          const reg = /^南方\+网友\d{8}$/gi
          if (reg.test(oldUserName)) {
            commit("setUserInfo", { userName })
          }
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    setUserInfo({ commit }, userInfo) {
      window.console.log("setUserInfo", userInfo)
      if (userInfo) {
        commit("setUserInfo", userInfo)
      }
    }
  }
}
